import React from "react";
import { IconType } from "react-icons";
import { Link } from "react-router-dom";
import styles from "./NavButton.module.scss";

interface NavButtonProps {
  icon: IconType;
  onClick?: () => void;
  to?: string;
  label: string;
  isActive?: boolean;
}

export default function NavButton({
  icon: Icon,
  onClick,
  to,
  label,
  isActive = false,
}: NavButtonProps) {
  const className = `${styles.navButton} ${isActive ? styles.active : ""}`;

  const content = (
    <>
      <Icon size={24} />
      <span className={styles.label}>{label}</span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={className} aria-label={label}>
        {content}
      </Link>
    );
  }

  return (
    <button className={className} onClick={onClick} aria-label={label}>
      {content}
    </button>
  );
}